import styled from 'styled-components';

import {colors} from 'theme';

export {EventBadge} from 'components/common/AuditLog/styled';

export const ChangesTable = styled.table`
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    border: 1px solid ${colors.border};
    th,
    td {
        padding: 12px 16px;
        text-align: left;
        overflow-wrap: anywhere;
        white-space: pre-wrap;
        border-bottom: 1px solid ${colors.border};
    }
    th {
        background: ${colors.background};
        color: ${colors.textSecondary};
        font-size: 12px;
        font-weight: 500;
    }
    td {
        font-size: 14px;
    }
`;
